// eslint-disable-next-line import/no-default-export
class HeaderScroll extends HTMLElement {
  constructor () {
    super()

    this.productTemplate = document.querySelector('.template-product')
    this.isTicking = false
    // eslint-disable-next-line
    this.lastKnownY = window.scrollY
    this.offsetTrackedY = 0
    this.scrollOffset = 100
    this.safeZone = 50
    this.scrollDirection = ''

    this.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.calculateHeight()
    this.updateEl()
  }

  setupListeners () {
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.onResize.bind(this))
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    // eslint-disable-next-line
    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
  }

  onResize () {
    this.calculateHeight()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setSize()
    this.setVisibility()
    this.setBodyClass()
  }

  setSize () {
    this.classList.toggle('hd-Banner-small', this.headerIsSmaller)
  }

  setVisibility () {
    this.classList.toggle('hd-Banner-hidden', !this.shouldBeVisible)
  }

  setBodyClass () {
    if (!this.productTemplate) return

    this.productTemplate.classList.toggle(
      'prd-Banner-small',
      this.headerIsSmaller
    )
    this.productTemplate.classList.toggle(
      'prd-Banner-hidden',
      !this.shouldBeVisible
    )
  }

  calculateHeight () {
    document.documentElement.style.setProperty(
      '--Nav_Height',
      `${this.offsetHeight}px`
    )
  }

  get shouldBeVisible () {
    if (this.lastKnownY <= this.containerEl.offsetHeight + this.safeZone * 2) {
      return true
    }

    if (this.scrollDirection === 'down') {
      return !this.isOverOffset
    } else if (this.scrollDirection === 'up') {
      return this.isOverOffset
    }
  }

  get isOverOffset () {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    }
  }

  get headerIsSmaller () {
    return this.lastKnownY > this.safeZone
  }

  get containerEl () {
    return this.closest('[data-header-container-el]')
  }
}

customElements.define('header-scroll', HeaderScroll)
